// extracted by mini-css-extract-plugin
module.exports = {"container":"QuizFooter_container__371J_"};